import { createPortalComponent } from 'utils/createPortalComponent'

export const { Target, Source } = createPortalComponent()
